<template>
    <el-table-column
      header-align="center"
      :prop="localProp.prop"
      :label="localProp.label"
      :key="localProp.label"
      :align="localProp.align"
      :type="localProp.type"
      :index="localProp.index"
      :fixed="localProp.fixed"
      :width="localProp.type === 'index' ? (localProp.width ? localProp.width : 100) : localProp.fixedWidth"
      :min-width="localProp.width"
      :label-class-name="'stone-table-label ' + (localProp.labelClass ? localProp.labelClass : '')"
      :class-name="'stone-table-cell ' + (localProp.class ? localProp.class : '')"
      :formatter="localProp.formatter"
      :show-overflow-tooltip="localProp.tooltip"
      :sortable="getSortable(localProp.sortable)"
      :selectable="localProp.selectable">
    </el-table-column>
</template>

<script>
export default {
  props: {
    prop: {
      type: Object,
      required: true
    },
    sortable: {
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      localProp: this.prop,
      localSortable: this.sortable
    }
  },
  methods: {
    getSortable: function (value) {
      if (!this.localSortable) {
        return false
      }
      return value === undefined ? 'custom' : value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stone-data-table-column/stone-data-table-column.vue